import { render } from "./demographic-charts.vue?vue&type=template&id=02fe096e&scoped=true&ts=true"
import script from "./demographic-charts.vue?vue&type=script&lang=ts"
export * from "./demographic-charts.vue?vue&type=script&lang=ts"

import "./demographic-charts.vue?vue&type=style&index=0&id=02fe096e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fe096e"]])

export default __exports__